import React from "react";
import { cfdiUseOptions, paymentMethodOptions, taxRegimeOptions } from "../constants/billing-options";
import "./upload-csf.css";
import { CSF_URL } from "../../common/utils/util";

interface UploadCsfProps {
  orderId: string;
  rfc: string;
  csf: string;
  cfdi_use?: string | null;
  payment_method?: string | null;
  tax_regime?: string | null;
}

const UploadCsf: React.FC<UploadCsfProps> = ({ 
  orderId, 
  rfc,
  csf, 
  cfdi_use, 
  payment_method,
  tax_regime
}) => {
  // Función helper para obtener la etiqueta de CFDI use
  const getCfdiUseLabel = (value: string): string => {
    const option = cfdiUseOptions.find(opt => opt.value === value);
    return option ? option.label : value;
  };

  // Función helper para obtener la etiqueta de payment method
  const getPaymentMethodLabel = (value: string): string => {
    const option = paymentMethodOptions.find(opt => opt.value === value);
    return option ? option.label : value;
  };

  // Función helper para obtener la etiqueta de tax regime
  const getTaxRegimeLabel = (value: string): string => {
    const option = taxRegimeOptions.find(opt => opt.value === value);
    return option ? option.label : value;
  };

  if (csf === null) {
    return null;
  }

  return (
    <div className="container-upload-csf">
      <div className="csfInfo">
        <h3 className="csfTitle">
          Ya cuentas con una constancia fiscal en tu pedido, la factura se
          generará a partir de tu constancia fiscal.{" "}
          <a
            href={`${CSF_URL}${orderId}.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "black", fontWeight: "bold", textDecoration: "underline" }}
          >
            Aquí puedes ver tu constancia subida
          </a>
        </h3>
        
        {(cfdi_use || payment_method || tax_regime) && (
          <div className="csfDetails">
            <h4>Información de Facturación:</h4>
            <div className="detailItem">
              <strong>RFC:</strong> {rfc}
            </div>
            {cfdi_use && (
              <div className="detailItem">
                <strong>Uso de CFDI:</strong> {getCfdiUseLabel(cfdi_use)}
              </div>
            )}
            {payment_method && (
              <div className="detailItem">
                <strong>Forma de Pago:</strong> {getPaymentMethodLabel(payment_method)}
              </div>
            )}
            {tax_regime && (
              <div className="detailItem">
                <strong>Régimen Fiscal:</strong> {getTaxRegimeLabel(tax_regime)}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadCsf;
